import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEyeSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M8.95203 4.23817C12.3429 3.77438 15.8815 5.56829 18.1296 9.61992C18.2608 9.8563 18.2609 10.1435 18.1297 10.3799C17.7584 11.0491 17.3519 11.6568 16.9167 12.2028"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.08926 1.91074C2.76382 1.58531 2.23618 1.58531 1.91074 1.91074C1.58531 2.23618 1.58531 2.76382 1.91074 3.08926L2.5 2.5L3.08926 1.91074ZM16.9107 18.0893C17.2362 18.4147 17.7638 18.4147 18.0893 18.0893C18.4147 17.7638 18.4147 17.2362 18.0893 16.9107L17.5 17.5L16.9107 18.0893ZM2.5 2.5L1.91074 3.08926L16.9107 18.0893L17.5 17.5L18.0893 16.9107L3.08926 1.91074L2.5 2.5Z"
      fill="currentColor"
    />
    <path
      d="M8.61061 9.079C8.86543 8.69574 8.76132 8.17848 8.37806 7.92366C7.99481 7.66884 7.47754 7.77295 7.22272 8.15621L7.91667 8.6176L8.61061 9.079ZM11.8438 12.7773C12.2271 12.5225 12.3312 12.0052 12.0764 11.622C11.8215 11.2387 11.3043 11.1346 10.921 11.3894L11.3824 12.0834L11.8438 12.7773ZM10 12.5V11.6667C9.07953 11.6667 8.33333 10.9205 8.33333 10H7.5H6.66667C6.66667 11.841 8.15905 13.3334 10 13.3334V12.5ZM7.5 10H8.33333C8.33333 9.65807 8.43542 9.34249 8.61061 9.079L7.91667 8.6176L7.22272 8.15621C6.87137 8.68464 6.66667 9.31969 6.66667 10H7.5ZM11.3824 12.0834L10.921 11.3894C10.6575 11.5646 10.342 11.6667 10 11.6667V12.5V13.3334C10.6803 13.3334 11.3154 13.1286 11.8438 12.7773L11.3824 12.0834Z"
      fill="currentColor"
    />
    <path
      d="M5.1068 5.83333C3.88213 6.73207 2.77233 7.9943 1.87029 9.62C1.73913 9.85639 1.73971 10.1448 1.87089 10.3812C4.79827 15.656 9.91313 17.1033 14.041 14.7234"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgEyeSlash;
